import moment from "moment-timezone";

const BUSINESS_TZ = "America/Toronto";

export const getInvoiceBusinessMonth = (invoice) => {
  const start = moment.utc(invoice.startDate).valueOf();
  const end = moment.utc(invoice.endDate).valueOf();

  const midpoint = start + (end - start) / 2;

  return moment.utc(midpoint).tz(BUSINESS_TZ).format("MMMM");
};
